"use client";

import { Dropdown, Item } from "@/components/dropdown";
import { Chevron } from "@/components/icons/chevron";
import { Button } from "react-aria-components";

export function HelpDropdown() {
	return (
		<Dropdown
			placement="bottom right"
			className="ml-auto"
			button={
				<Button className="hover:opacity-80">
					Help
					<Chevron className="w-4 h-4 text-muted-foreground ml-1 inline" />
				</Button>
			}
		>
			<Item
				onAction={() => {
					window.open("/docs", "_blank");
				}}
			>
				API reference
			</Item>
			<Item href="mailto:hello@whitecircle.ai">Support</Item>
		</Dropdown>
	);
}
